<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Cambiar Contraseña</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <form [formGroup]="ChangePasswordForm">
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Contraseña Actual</mat-label>
                    <mat-icon matSuffix>lock</mat-icon>
                    <input type="password" name="current_password" formControlName="currentPassword" matInput>
                    <mat-error *ngIf="ChangePasswordForm.get('currentPassword').hasError('required')">El Campo es Obligatorio</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Nueva Contraseña</mat-label>
                    <mat-icon matSuffix>vpn_key</mat-icon>
                    <input type="password" name="new_password" formControlName="newPassword" matInput>
                    <mat-error *ngIf="ChangePasswordForm.get('newPassword').hasError('required')">El Campo es Obligatorio</mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" fxFlex>
                    <mat-label>Repita Nueva Contraseña</mat-label>
                    <mat-icon matSuffix>verified_user</mat-icon>
                    <input type="password" name="new_password_confirm" formControlName="newPasswordConfirm" matInput>
                    <mat-error *ngIf="ChangePasswordForm.get('newPasswordConfirm').hasError('required')">El Campo es Obligatorio</mat-error>
                    <mat-error *ngIf="ChangePasswordForm.get('newPasswordConfirm').hasError('passwordsNotMatching')">Las contraseñas no coinciden</mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button 
            mat-button class="save-button" 
            (click)="CambiarContrasenia()"
            aria-label="SAVE"
            [disabled]="ChangePasswordForm.invalid"
        >
            CAMBIAR
        </button>
    </div>
</div>